/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 10:22:37
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-31 15:53:48
 */
import template from './template.html';
import type { TypeInputEmitData } from '@/app/editor/sidebar/interactions/animations/type';

/**
 * RangePickerControl
 */
export default class RangePickerControl {
  _$input: JQuery;
  _$interactionTab: JQuery;
  _$interactionPanel: JQuery;
  _options: any;
  _runnerChangeValue: any;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this._$input = $input;
    this._$interactionTab = jQuery('.simple-tabs');
    this._$interactionPanel = this._$interactionTab.find('.interactions-panel');
    this._options = options;
    this.renderTemplate();
  }

  /**
   * Render Input to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    this._$input.hide();
    const configs = {
      key: this._$input.data('key'),
      value: this._$input.val(),
      'value-type': this._$input.data('valuetype'),
      min: this._$input.data('min') || 0,
      max: this._$input.data('max') || 100,
      step: this._$input.data('step') || 1,
    };
    const html = template(configs);

    const $html = $(html);

    ($html.find('.gf-range-picker-slider') as any).slider({
      value: configs.value,
      min: configs.min,
      max: configs.max,
      step: configs.step,
      /**
       * Sliding
       * @param _event ..
       * @param ui ..
       */
      slide: function (_event: any, ui: any) {
        const value = ui.value;
        $html.find('.gf-range-picker-text input').val(value);
      },
      /**
       * Stop slider
       * @param _event ..
       * @param ui ..
       */
      stop: function (_event: any, ui: any) {
        const key = _this._$input.data('key') || '';
        const value = ui.value;
        const inputType = _this._$input.data('inputtype') || '';
        const configType = _this._$input.data('key') || '';

        const data: TypeInputEmitData = {
          key: key,
          value: value,
          inputType: inputType,
          type: configType,
        };
        if (_this._options && _this._options.onChange) {
          _this._options.onChange(data);
        }
      },
    });

    const $rangePickerText = $html.find('.gf-range-picker-text input');
    $rangePickerText.off('keyup paste').on('keyup paste', function () {
      _this._runnerChangeValue && clearTimeout(_this._runnerChangeValue);
      _this._runnerChangeValue = setTimeout(() => {
        let value = $rangePickerText.val() || '';
        if (value == '') value = _this._$input.data('min');

        if (value !== '') {
          const key = _this._$input.data('key') || '';
          const inputType = _this._$input.data('inputtype') || '';
          const configType = _this._$input.data('key') || '';

          const data: TypeInputEmitData = {
            key: key,
            value: value.toString(),
            inputType: inputType,
            type: configType,
          };
          if (_this._options && _this._options.onChange) {
            _this._options.onChange(data);
            _this.setValue(value.toString());
          }
        }
      }, 600);
    });

    this._$input.after($html);
  }

  /**
   * Set value to input
   * @param val ..
   * @returns void
   */
  setValue(val: string): void {
    this._$input.val(val);

    const $gfRangePicker = this._$input.next();
    const $rangePickerScoll = $gfRangePicker.find('.gf-range-picker-slider span');
    const $rangePickerText = $gfRangePicker.find('.gf-range-picker-text input');

    const max = parseFloat(this._$input.data('max'));
    const min = parseFloat(this._$input.data('min'));
    if (val === '' || val == 'auto') {
      $rangePickerText.val(val);
      val = min.toString();
    } else {
      if (val[val.length - 1] !== '.') {
        val = (Math.round(parseFloat(val) * 100) / 100).toString();
      }
      //thả cửa trường hợp value lớn hơn max (vì vẫn có trường hợp khách muốn lớn hơn max. Nhỏ hơn min thì hiếm :D)
      if (parseFloat(val) < parseFloat(min.toString())) {
        val = min.toString();
      }
      $rangePickerText.val(val);
    }

    // var percentage = Math.abs(value - min);
    const percentage = parseFloat(val) - min;
    const distance = Math.abs(max - min);
    let left = (percentage / distance) * 100;
    if (left > 100) {
      left = 100;
    } else if (left < 0) {
      left = 0;
    }
    $rangePickerScoll.css({
      left: left + '%',
    });
  }
}
